<template>
  <div style="width: 100%; height: 100%">
    <div class="equipmentList">
      <div class="container">
        <div>
          <span>{{ $t('device.title') }}</span>
        </div>
        <div>
          <a-space>
            <a-button
              type="primary"
              @click="searchDeviceList"
              v-if="authorities.find(a => a.code === 'device:manage:device:query' || a.code === 'agent:device:manage:device:query')"
            >{{ $t('buttons.search') }}</a-button>
            <a-button
              key="submit"
              type="primary"
              @click="toInsertView"
              v-if="authorities.find(a => a.code === 'device:manage:device:insert' || a.code === 'agent:device:manage:device:insert')"
            >{{ $t('buttons.add') }}</a-button>
            <a-button
              key="submit"
              type="primary"
              @click="exportDevice"
              :loading="isExporting"
              v-if="authorities.find(a => a.code === 'device:manage:device:export')"
            >{{ $t('buttons.export') }}</a-button>
          </a-space>
        </div>
      </div>
      <div style="background-color: #fff; margin-top: 10px; position: relative">
        <div v-show="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, .6); z-index: 1000; display: flex; justify-content: center; align-items: center">
        <a-spin />
      </div><el-table
        :data="list"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#fafafa' }"
      >
        <el-table-column prop="code" label="整机编号" width = "160">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.code') }}<span class="icons ASC" style="cursor: pointer;" data-index="code">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="code" />
          </template>
          <template slot-scope="scope">
            <a @click.stop="gotoDevice(scope.row)"><text-highlight :queries="highLightInfo[0].value">{{ scope.row.code }}</text-highlight></a>
            <!-- <text-highlight v-else :queries="highLightInfo[0].value">{{ scope.row.code }}</text-highlight> -->
          </template>
        </el-table-column>
        <el-table-column prop="name" label="设备名称" width = "140">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.deviceName') }}<span class="icons unset" style="cursor: pointer;" data-index="name">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[1].value" />
          </template>
          <template slot-scope="scope">
            <a v-if="authorities.find(a => a.code === 'device:manage:device:history:query')" @click="$router.push({ path: '/equipment/preview', query: { code: scope.row.code, name: scope.row.name, driver: scope.row.driverType, pc: scope.row.protocolCode, type: scope.row.type, id: scope.row.id, ci: scope.row.customer ? scope.row.customer.id : '', rateInterval: scope.row.intervalTime }})"><text-highlight :queries="highLightInfo[1].value">{{ scope.row.name }}</text-highlight></a>
            <text-highlight v-else :queries="highLightInfo[1].value">{{ scope.row.name }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="规格型号" width = "100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.model') }}<span class="icons unset" style="cursor: pointer;" data-index="model">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[2].value" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo[2].value">{{ scope.row.model }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="设备类型" :width="lang === 'en' ? '150' : '125'">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.deviceType') }}</div>
            <a-select :style="`width: ${ lang === 'en' ? '130' : '115' }px`" v-model="queryParams.query[9].value" @change="searchDeviceList">
              <a-select-option value="">{{ $t('common.all') }}</a-select-option>
              <a-select-option v-for="(value, key) in typeMap" :key="key">
                {{ value }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            {{ typeMap[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="运行状态" width="100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.status') }}</div>
            <a-select style="width: 80px" v-model="queryParams.query[10].value" @change="searchDeviceList">
              <a-select-option value="">{{ $t('common.all') }}</a-select-option>
              <a-select-option v-for="(value, key) in statusMap" :key="key">
                {{ value }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            <!-- <span :key="s" :style="{ color: (s && runningStatus[s]) ? runningStatus[s].color : '' }">{{ (s && runningStatus[s]) ? runningStatus[s][lang] : '' }}<span v-if="i < scope.row.status.length - 1">, </span> </span> -->
            <span v-for="(s, i) in scope.row.status" :key="s">
              <span :style="{ color: (s && runningStatus[s]) ? runningStatus[s].color : '' }">{{ (s && runningStatus[s]) ? runningStatus[s][lang] : '' }}</span>
              <span v-if="i < scope.row.status.length - 1">&nbsp;&nbsp;</span> 
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="customer.company" label="客户名称" width = "220">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.customerName') }}<span class="icons unset" style="cursor: pointer;" data-index="customer.company">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[3].value" />
          </template>
          <template slot-scope="scope">
            <a v-if="ca.find(a => a.code === 'customer:update' || a.code === 'agent:customer:update')" @click.stop="$router.push({ path: '/customer/detail', query: { id: scope.row.customer ? scope.row.customer.id : '' } })"><text-highlight :queries="highLightInfo[3].value">{{ scope.row.customer ? scope.row.customer.company : '' }}</text-highlight></a>
            <text-highlight v-else :queries="highLightInfo[3].value">{{ scope.row.customer ? scope.row.customer.company : '' }}</text-highlight>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="users" label="用户" width="80">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.user') }}<span class="icons unset" style="cursor: pointer;" data-index="5">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[4].value" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo[4].value">{{ scope.row.users }}</text-highlight>
          </template>
        </el-table-column> -->
        <el-table-column prop="organizations" label="归属组织" width = "140">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.organization') }}<span class="icons unset" style="cursor: pointer;" data-index="organizations">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[5].value" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo[5].value">{{ scope.row.organizations }}</text-highlight>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="businessType" label="业务类型" width = "120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.businessType') }}</div>
            <a-select
              style="width: 100px"
              v-model="queryParams.query[12].value"
              @change="searchDeviceList"
            >
              <a-select-option value="">{{ $t('common.all') }}</a-select-option>
              <a-select-option v-for="(v, k) in businessTypes" :key = k>
                {{ v }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            {{ businessTypes[scope.row.businessType] }}
          </template>
        </el-table-column> -->
        <el-table-column prop="startTime" label="省" width = "100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('binding.province') }}</div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[13].value" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo[9].value">{{ scope.row.customer ? scope.row.customer.province : "" }}</text-highlight>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="startTime" label="开始时间" width = "100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.startTime') }}<span class="icons unset" style="cursor: pointer;" data-index="startTime">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.startTime }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="结束时间" width = "100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.endTime') }}<span class="icons unset" style="cursor: pointer;" data-index="endTime">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column prop="countDown" label="倒计时" width = "110">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.countDown') }}<span class="icons unset" style="cursor: pointer;" data-index="countDown">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input-number allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.filter[1].value" />
          </template>
          <template slot-scope="scope">
            <span :class="{ red: scope.row.countDown <= 7, yellow: scope.row.countDown > 7 && scope.row.countDown <= 30, green: scope.row.countDown > 30 }">{{ scope.row.countDown }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="dtuStatus" label="模块状态" :width="lang === 'en' ? '115' : '80'">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.dtuStatus') }}</div>
            <a-select v-model="queryParams.query[11].value" :style="`width: ${ lang === 'en' ? 105 : 70 }px`" @change="searchDeviceList">
              <a-select-option value="">{{ $t('common.all') }}</a-select-option>
              <a-select-option v-for="(v, k) in dtuStatus" :key="k">
                {{ v }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            <span :style="{ color: (scope.row.dtuStatus && runningStatus[scope.row.dtuStatus]) ? runningStatus[scope.row.dtuStatus].color : '' }">{{ dtuStatus[scope.row.dtuStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dtuCode" label="模块编号" width = "130">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.dtuCode') }}<span class="icons unset" style="cursor: pointer;" data-index="dtuCode">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[8].value" />
          </template>
          <template slot-scope="scope">
            <a-popconfirm
              :title="$t('device.rsm')"
              :ok-text="$t('common.yes')"
              :cancel-text="$t('common.no')"
              @confirm="reStartDtu(scope.row.dtuCode, scope.$index)"
            >
              <a><a-spin size="small" v-show="list[scope.$index].loading" /><text-highlight :queries="highLightInfo[8].value">{{ scope.row.dtuCode }}</text-highlight></a>
            </a-popconfirm>
          </template>
        </el-table-column>
        <el-table-column prop="protocolCode" label="协议编号" width = "130">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.protocolCode') }}<span class="icons unset" style="cursor: pointer;" data-index="protocolCode">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[7].value" />
          </template>
          <template slot-scope="scope">
            <a v-if="pa.find(a => a.code === 'device:manage:device:protocol:update')" @click.stop="$router.push({ path: '/equipment/protocol/submit', query: { code: scope.row.protocolCode } })"><text-highlight :queries="highLightInfo[7].value">{{ scope.row.protocolCode }}</text-highlight></a>
            <text-highlight v-else :queries="highLightInfo[7].value">{{ scope.row.protocolCode }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="driverType" label="驱动类型" width = "140">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.driverType') }}<span class="icons unset" style="cursor: pointer;" data-index="driverType">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input allow-clear @keyup.enter="searchDeviceList" v-model.trim="queryParams.query[6].value" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo[6].value">{{ scope.row.driverType }}</text-highlight>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="tag" label="预警标记" width = "150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.warningTag') }}</div>
            <a-select style="width: 100%;" v-model="tag" @change="handleTagChange" dropdownClassName="warningTagOption">
              <a-select-option value="all">{{ $t('common.all') }}</a-select-option>
              <a-select-option v-for="w in warningTags" :key="w.value">
                {{ w.text }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            {{ scope.row.tag }}
          </template>
        </el-table-column> -->
        <el-table-column prop="createdAt" label="创建日期" width = "160">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.createdAt') }}<span class="icons unset" style="cursor: pointer;" data-index="createdAt">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span></div>
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" label="更新日期" width = "160">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.updatedAt') }}<span class="icons DESC" style="cursor: pointer;" data-index="updatedAt">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
          </template>
        </el-table-column>
        <el-table-column prop="enabled" label="拆除状态" width="95">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.enable') }}</div>
            <a-select style="width: 85px" :default-value="1" @change="handleEnabledChange">
              <a-select-option :value="1">{{ $t('device.no') }}</a-select-option>
              <a-select-option :value="0">{{ $t('device.yes') }}</a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            <a-switch @change="showConfirm(scope.row)" :checked-children="$t('device.no')" :un-checked-children="$t('device.yes')" :checked="scope.row.enabled" />
            <!-- <span v-else>{{$t('device.yes')}}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="enabled" label="禁用参数写入" width="140">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.modifyParameter') }}</div>
            <a-select style="width: 120px" default-value="" @change="handleModifyParameterChange">
              <a-select-option value="">{{ $t("common.all") }}</a-select-option>
              <a-select-option :value="0">{{ $t('common.yes') }}</a-select-option>
              <a-select-option :value="1">{{ $t('common.no') }}</a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            <a-switch v-if="authorities.find(a => a.code === 'device:running:parameter:update')" @change="showConfirm_modifyParameter(scope.row)" :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" :checked="!scope.row.modifyParameter" />
            <span v-else>{{ scope.row.modifyParameter ? $t('common.no') : $t("common.yes") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" :width="flexColumnWidth()">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operation') }}</div>
          </template>
          <template slot-scope="scope">
            <a-button style="padding-left: 0" type="link" @click="onEdit(scope.row)" v-show="authorities.find(a => a.code === 'device:manage:device:update' || a.code === 'agent:device:manage:device:update')">{{ $t('buttons.edit') }}</a-button>
            <a-popconfirm
              :title="$t('messages.ctrd')"
              :ok-text="$t('common.okText')"
              :cancel-text="$t('common.cancelText')"
              v-show="authorities.find(a => a.code === 'device:manage:device:delete' || a.code === 'agent:device:manage:device:delete')"
              @confirm="removeDevice(scope.row.id)"
            >
              <a-button type="link" style="padding-left: 0" v-show="authorities.find(a => a.code === 'device:manage:device:delete' || a.code === 'agent:device:manage:device:delete')">{{ $t('buttons.delete') }}</a-button>
            </a-popconfirm>
            <a-button style="padding-left: 0" type="link" @click="$router.push({
              name: 'history',
              params: {
                machineId: scope.row.code,
                machineType: scope.row.model,
                protocolCode: scope.row.protocolCode,
                id: scope.row.id,
                intervalTime: scope.row.intervalTime,
                name: scope.row.name
                // port_no: list[0].port_no
              }
            })" v-show="authorities.find(a => a.code === 'device:manage:device:history:query')">{{ $t('device.history') }}</a-button>
            <!-- <a-button v-show="authorities.find(a => a.code === 'device:position:history:query')" style="padding-left: 0" type="link" @click="$router.push({ path: '/equipment/comprass', query: { deviceCode: scope.row.code, from: 'list' } })">历史定位</a-button> -->
          </template>
        </el-table-column>
      </el-table></div>

      <a-pagination
        style="float: right; margin-top: 20px; padding-bottom: 20px"
        show-size-changer
        :current="pagination.current"
        :pageSizeOptions="pagination.pageSizeOptions"
        :total="pagination.total"
        @change="handleTableChange"
        @showSizeChange="handleTableChange"
      />
      <!-- <a-table
        class="table"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :rowKey="(record, index) => record.id"
        :pagination="pagination"
        @change="tableChange"
        :scroll="{x: 2000}"
      >
        <template v-slot:code="text">
          <text-highlight :queries="[highLightInfo.code]">{{text}}</text-highlight>
        </template>
        <template v-slot:dtuCode="text">
          <text-highlight :queries="[highLightInfo.dtuCode]">{{text}}</text-highlight>
        </template>
        <template v-slot:driverType="text">
          <text-highlight :queries="[highLightInfo.driverType]">{{text}}</text-highlight>
        </template>
        <template v-slot:status="text">
          <span :style="{ color: runningStatus[text].color }">{{ runningStatus[text].label }}</span>
        </template>
        <template v-slot:model="text">
          <text-highlight :queries="[highLightInfo.model]">{{text}}</text-highlight>
        </template>
        <template v-slot:company="text">
          <text-highlight :queries="[highLightInfo['customer.company']]">{{text}}</text-highlight>
        </template>
        <template v-slot:organizations="text">
          <text-highlight :queries="[highLightInfo['customer.users.organizationName']]">{{text}}</text-highlight>
        </template>
        <template v-slot:users="text">
          <text-highlight :queries="[highLightInfo['customer.users.realName']]">{{text}}</text-highlight>
        </template>
        <template v-slot:type="text">
          {{ typeMap[text] }}
        </template>
        <template v-slot:updatedAt="text, record">
          {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm') }}
        </template>
        <template v-slot:createdAt="text, record">
          {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm') }}
        </template>
        <template v-slot:runningStatus="text">
          <span :style="{color: runningStatus[text]}">{{text}}</span>
        </template>
        <template v-slot:operation="text, record">
          <a-button type="link" @click="onEdit(record)" :disabled="!authorities.find(a => a.code === 'device:manage:device:update')">编辑</a-button>
          <a-popconfirm
            title="确认要删除吗?"
            ok-text="确认"
            cancel-text="取消"
            @confirm="removeDevice(record.id)"
          >
            <a-button type="link" :disabled="!authorities.find(a => a.code === 'device:manage:device:delete')">删除</a-button>
          </a-popconfirm>
        </template>
        <template v-slot:name="text, record">
          <a href="javascript:;" @click="$router.push({ path: '/equipment/preview', query: { code: record.code, name: record.name, driver: record.driverType, pc: record.protocolCode, type: record.type, id: record.id }})"><text-highlight :queries="[highLightInfo.name]">{{text}}</text-highlight></a>
        </template>
        <template v-slot:protocolCode="text, record">
          <a-button type="link" style="padding: 0; white-space: wrap" @click="() => { $router.push({ path: '/equipment/protocol/submit', query: { code: record.protocolCode, driverType: record.driverType } }) }"><text-highlight :queries="[highLightInfo.protocolCode]">{{text}}</text-highlight></a-button>
        </template>
        html 中的插槽 information是变量点击控制改变颜色
      </a-table>-->
      <equipment-drawer
        :visible="equipmentDrawer.visible"
        :type="0"
        :equipment="equipmentDrawer.data"
        @close="equipmentDrawer.visible = false"
        :close-drawer="closeDrawer"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import { columns } from './data'
import { searchDeviceList, deleteDevice, updateDevice, reStart, exportDevice, putModifyParameter } from "@/api/device";
import EquipmentDrawer from "@/views/EquipmentManager/EquipmentList/components/EquipmentDrawer";
import TextHighlight from "vue-text-highlight";
import { getDict } from "@/api/dict";
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

export default {
  name: "index",
  components: {
    EquipmentDrawer,
    TextHighlight
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a.concat(this.getAuthorities('/equipment/comprass'))
    } else {
      this.authorities = this.getAuthorities(this.$route.path).concat(this.getAuthorities('/equipment/comprass'))
    }
    this.ca = this.getAuthorities('/customer')
    this.pa = this.getAuthorities('/equipment/protocol')
    sessionStorage.setItem('authorities', JSON.stringify(this.authorities))
    if (this.$store.state.deviceFlag) {
      this.searchDeviceList()
      this.$store.commit('setDeviceFlag', false)
    }
  },
  created () {
    locale.use(this[this.lang])
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
    this.ca = this.getAuthorities('/customer')
    this.pa = this.getAuthorities('/equipment/protocol')
    sessionStorage.setItem('authorities', JSON.stringify(this.authorities))
    this.searchDeviceList();
    this.getDict();
  },
  data() {
    return {
      isExporting: false,
      pagination: {
        defaultPageSize: 100,
        defaultCurrent: 1,
        current: 1,
        pageSize: 100,
        total: 6000,
        showSizeChanger: true
      },
      en,
      zh,
      authorities: [],
      ca: [],
      pa: [],
      code: '',
      statusMap: {},
      deviceTypeMap: {},
      columns: [
        {
          title: (
            <div>
              整机编号
              <span class="icons unset" style="cursor: pointer;" data-index="0">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                class="username"
                type="text"
                allow-clear
                data-index="0"
              />
            </div>
          ),
          dataIndex: "code",
          key: "code",
          scopedSlots: {
            customRender: "code"
          }
        },
        {
          title: (
            <div>
              设备名称
              <span class="icons unset" style="cursor: pointer;" data-index="1">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="1"
              />
            </div>
          ),
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: (
            <div>
              规格型号
              <span class="icons unset" style="cursor: pointer;" data-index="2">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="2"
              />
            </div>
          ),
          dataIndex: "model",
          key: "model",
          scopedSlots: {
            customRender: "model"
          }
        },
        {
          title: (
            <div>
              运行状态
              <span class="icons unset" style="cursor: pointer;" data-index="3">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="3"
              />
            </div>
          ),
          dataIndex: "status",
          key: "status",
          scopedSlots: {
            customRender: "status"
          }
        },
        {
          title: (
            <div>
              客户名称
              <span class="icons unset" style="cursor: pointer;" data-index="4">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="4"
              />
            </div>
          ),
          dataIndex: "customer.company",
          key: "customer.company",
          scopedSlots: {
            customRender: "company"
          }
        },
        {
          title: (
            <div>
              用户
              <span class="icons unset" style="cursor: pointer;" data-index="5">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="5"
              />
            </div>
          ),
          dataIndex: "users",
          key: "customer.users.realName",
          scopedSlots: {
            customRender: "users"
          }
        },
        {
          title: (
            <div>
              归属组织
              <span class="icons unset" style="cursor: pointer;" data-index="6">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="6"
              />
            </div>
          ),
          dataIndex: "organizations",
          key: "customer.users.organizationName",
          scopedSlots: {
            customRender: "organizations"
          },
          width: 150
        },
        {
          title: (
            <div>
              驱动类型
              <span class="icons unset" style="cursor: pointer;" data-index="7">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username"
                allow-clear
                data-index="7"
              />
            </div>
          ),
          dataIndex: "driverType",
          key: "driverType",
          scopedSlots: {
            customRender: "driverType"
          }
        },
        {
          title: (
            <div>
              设备类型
              <br />
              <a-select>
                <a-select-option value="0">全部</a-select-option>
                <a-select-option value="KYJ">空压机</a-select-option>
                <a-select-option value="DB">电表</a-select-option>
                <a-select-option value="DMLK">德曼联空</a-select-option>
                <a-select-option value="KQJCY">空气检测仪</a-select-option>
                <a-select-option value="LDY">露点仪</a-select-option>
                <a-select-option value="LGJ">冷干机</a-select-option>
              </a-select>
            </div>
          ),
          dataIndex: "type",
          key: "type",
          scopedSlots: {
            customRender: "type"
          }
        },
        {
          title: (
            <div>
              协议编号
              <span class="icons unset" style="cursor: pointer;" data-index="9">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username search"
                allow-clear
                data-index="9"
              />
            </div>
          ),
          dataIndex: "protocolCode",
          key: "protocolCode",
          scopedSlots: { customRender: "protocolCode" },
          width: 150
        },
        {
          title: (
            <div>
              模块编号
              <span
                class="icons unset"
                style="cursor: pointer;"
                data-index="10"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                type="text"
                class="username search"
                allow-clear
                data-index="10"
              />
            </div>
          ),
          dataIndex: "dtuCode",
          key: "dtuCode",
          scopedSlots: { customRender: "dtuCode" }
        },
        {
          title: (
            <div>
              创建日期
              <span
                class="icons unset"
                style="cursor: pointer; right: -52px"
                data-index="11"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          ),
          dataIndex: "createdAt",
          key: "createdAt",
          width: "9%",
          scopedSlots: { customRender: "createdAt" }
        },
        {
          title: (
            <div>
              更新日期
              <span
                class="icons DESC"
                style="cursor: pointer; right: -52px"
                data-index="12"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          ),
          dataIndex: "updatedAt",
          key: "updatedAt",
          width: "9%",
          scopedSlots: { customRender: "updatedAt" }
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          scopedSlots: { customRender: "operation" },
          fixed: "right"
        }
      ],
      statuseMap: {},
      // highLightInfo: {
      //   code: "",
      //   name: "",
      //   "customer.company": "",
      //   "customer.users.organizationName": "",
      //   "customer.users.realName": "",
      //   model: "",
      //   driverType: "",
      //   protocolCode: "",
      //   dtuCode: ""
      // },
      searchInput: null,
      rowSelection: {
        selectedRowKeys: [],
        onChange: this.rowChange
      },
      runningStatus: {
        online: {
          color: "#0eed24",
          zh: "在线",
          en: 'Online'
        },
        running: {
          color: "#0eed24",
          zh: "运行",
          en: 'Running'
        },
        maintain: {
          color: "#ff681c",
          zh: "保养",
          en: 'Maintain'
        },
        error: {
          color: "#e82127",
          zh: "故障",
          en: 'Error'
        },
        standby: {
          color: "#11d7f5",
          zh: "停机",
          en: 'Standby'
        },
        sleep: {
          color: "#11d7f5",
          zh: "待机",
          en: 'Sleep'
        },
        offline: {
          color: "#4d4d4d",
          zh: "离线",
          en: 'Offline'
        },
        prepare: {
          color: "#4d4d4d",
          zh: "备机",
          en: 'Prepare'
        }
      },
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showSizeChanger: true
      },
      loading: false,
      equipmentDrawer: {
        visible: false,
        type: 0,
        data: {}
      },
      selectedKeys: [""],
      searchInfo: {
        text: {
          deviceCode: "",
          deviceName: "",
          model: "",
          brand: "",
          companyName: ""
        },
        column: {
          deviceCode: false,
          deviceName: false,
          model: false,
          brand: false,
          companyName: false
        }
      },
      sortInfo: [],
      collapsed: false,
      state: "",
      highLightInfo: [
        {
          field: 'code',
          value: ''
        },
        {
          field: 'name',
          value: ''
        },
        {
          field: 'model',
          value: ''
        },
        {
          field: 'customer.company',
          value: ''
        },
        {
          field: 'customer.users.realName',
          value: ''
        },
        {
          field: 'customer.users.organizationName',
          value: ''
        },
        {
          field: 'driverType',
          value: ''
        },
        {
          field: 'protocolCode',
          value: ''
        },
        {
          field: 'dtuCode',
          value: ''
        },
        {
          field: "customer.province",
          value: ""
        }
      ],
      queryParams: {
        query: [
          {
            field: 'code',
            value: ''
          },
          {
            field: 'name',
            value: ''
          },
          {
            field: 'model',
            value: ''
          },
          {
            field: 'customer.company',
            value: ''
          },
          {
            field: 'customer.users.realName',
            value: ''
          },
          {
            field: 'customer.users.organizationName',
            value: ''
          },
          {
            field: 'driverType',
            value: ''
          },
          {
            field: 'protocolCode',
            value: ''
          },
          {
            field: 'dtuCode',
            value: ''
          },
          {
            field: 'type',
            value: ''
          },
          {
            field: 'status',
            value: ''
          },
          {
            field: 'dtuStatus',
            value: ''
          },
          {
            field: 'businessType',
            value: ''
          },
          {
            field: "customer.province",
            value: ""
          }
        ],
        filter: [
          {
            field: 'enabled',
            value: true
          },
          {
            field: 'countDown',
            value: '',
            req: 'le'
          }
        ],
        sort: [
          {
            field: "updatedAt",
            value: "DESC"
          },
          {
            field: 'code',
            value: 'ASC'
          }
        ]
      },
      s: {
        status: '',
        type: ''
      },
      typeMap: {},
      dtuStatus: {},
      businessTypes: {},
      warningTags: [],
      tag: ""
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    async lang(v) {
      locale.use(this[v])
      await this.getDict()
      this.list = [...this.list]
    }
  },
  mounted() {
    this.$nextTick(() => {
    const ss = document.querySelectorAll(
      "span.icons"
    );
    console.log(ss);
    ss.forEach(i => {
      i.addEventListener("click", () => {
        let c = "";
        switch (i.classList[1]) {
          case "ASC":
            c = "DESC";
            break;
          case "DESC":
            c = "unset";
            break;
          case "unset":
            c = "ASC";
            break;
          default:
            break;
        }
        i.classList.remove(i.classList[1]);
        i.classList.add(c);
        // const ii = document.querySelectorAll(
        //   "div span.icons:not(.unset)"
        // );
        // console.log(ii);
        const index = i.dataset["index"]
        
        const f = this.queryParams.sort.findIndex(s => s.field === index)
        if (f >= 0) {
          if (i.classList[1] === 'unset') {
            this.queryParams.sort.splice(f, 1)
          } else {
            this.queryParams.sort[f].value = i.classList[1]
          }
        } else {
          if (i.classList[1] !== 'unset') {
            this.queryParams.sort.push({
              field: index,
              value: i.classList[1]
            })
          }
        }
        this.searchDeviceList();
      });
    });
    })
  },
  methods: {
    moment,
    flexColumnWidth () {
      let width = 0
      if (this.authorities.find(a => a.code === 'device:manage:device:update' || a.code === 'agent:device:manage:device:update')) {
        width += 40
      }
      if (this.authorities.find(a => a.code === 'device:manage:device:delete' || a.code === 'agent:device:manage:device:delete')) {
        width += 40
      }
      if (this.authorities.find(a => a.code === 'device:manage:device:history:query')) {
        width += this.lang === 'en' ? 140 : 120
      }
      return width
    },
    async getDict() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        const { data } = await getDict(lang, "deviceType");
        data.content.forEach(c => {
          this.typeMap[c.value] = c.text;
        });
      } catch (e) {
        console.log(e);
      }
      try {
        const { data } = await getDict(lang, "deviceStatus");
        data.content.forEach(c => {
          this.statusMap[c.value] = c.text;
        });
      } catch (e) {
        console.log(e);
      }
      try {
        const { data } = await getDict(lang, "dtuStatus");
        data.content.forEach(c => {
          this.dtuStatus[c.value] = c.text;
        });
      } catch (e) {
        console.log(e);
      }
      try {
        const { data } = await getDict(lang, "deviceBusinessType");
        data.content.forEach(c => {
          this.businessTypes[c.value] = c.text;
        });
      } catch (e) {
        console.log(e);
      }
      try {
        const { data } = await getDict(lang, "warningTag");
        this.warningTags = data.content
      } catch (e) {
        console.log(e);
      }
    },
    async tableChange(pagination) {
      this.loading = true;
      this.queryParams.query[0].value = this.code.split('-').join('')
      try {
        const { data } = await searchDeviceList(
          pagination.current,
          pagination.pageSize,
          this.queryParams
        );
        this.list = data.records.map(item => {
          item.organizations = {};
          item.users = {};
          (item?.customer?.users || []).forEach(u => {
            if (u.organizationName) {
              item.organizations[u.organizationName] = u.organizationName
            }
            if (u.realName) {
              item.users[u.realName] = u.realName
            }
          });
          item.organizations = Object.keys(item.organizations).join("，");
          item.users = Object.keys(item.users).join("，");
          item.createdAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss");
          item.updatedAt = moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss");
          item.startTime && (item.startTime = moment(item.startTime).format("YYYY-MM-DD"));
          item.endTime && (item.endTime = moment(item.endTime).format("YYYY-MM-DD"));
          item.status = item.status?.split(',') || []
          return item;
        });
        this.pagination.current = data.current;
        this.pagination.pageSize = data.size;
        this.pagination.total = data.total;
      } catch {
        // this.$message.error("请求失败")
      }
      this.loading = false;
    },
    async reStartDtu(dtuCode, i) {
      this.list[i].loading = true
      this.list = [...this.list]
      try {
        const { message } = await reStart(dtuCode)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        this.list[i].loading = false
        this.list = [...this.list]
      }
    },
    handleStatusSelect(value) {
      this.s.status = value
      for (let key in this.s) {
        if (this.s[key] && this.s[key] !== '0') {
          this.queryParams.filter.push({
            field: key,
            value: this.s[key]
          })
        }
      }
      this.searchDeviceList()
    },
    handleEnabledChange(value) {
      this.queryParams.filter[0] = {
        field: 'enabled',
        value: !!value
      }
      this.searchDeviceList()
    },
    handleModifyParameterChange(value) {
      if (value === "" && this.queryParams.filter[2]) {
        this.queryParams.filter.splice(2, 1)
      }
      if (value !== "") {
        this.queryParams.filter[2] = {
          field: 'modifyParameter',
          value: !!value
        }
      }
      this.searchDeviceList()
    },
    handleTypeSelect(value) {
      if (value !== '0') {
        this.queryParams.query.at(-1).value = value
      } else {
        this.queryParams.query.at(-1).value = ''
      }
      this.searchDeviceList()
    },
    rowChange(selectedRowKeys, selectedRows) {
      this.rowSelection.selectedRowKeys = selectedRowKeys;
    },
    handleCancel(e) {
      this.insertvisible = false;
    },
    toInsertView() {
      this.$router.push({ path: "/equipment/list/submit/add" });
    },
    async showConfirm(record) {
      this.$confirm({
        title: record.enabled ? this.$t('messages.ctd') : this.$t('messages.ctr'),
        content: record.enabled ? this.$t('messages.confirmD') : this.$t('messages.confirmR'),
        onOk: async () => {
          record.enabled = !record.enabled
          if (record.enabled) {
            record.dtuCode = record.dtuCode.substring(1)
          } else {
            record.dtuCode = 'T' + record.dtuCode
          }
          const form = {
            id: record.id,
            code: record.code,
            name: record.name,
            type: record.type,
            status: (record.status || []).join(','),
            enabled: record.enabled,
            deviceAddress: record.deviceAddress.length < 2 ? "0" + record.deviceAddress : record.deviceAddress,
            model: record.model,
            brand: record.brand,
            customerId: record.customerId,
            installAddress: record.installAddress,
            driverType: record.driverType,
            protocolCode: record.protocolCode,
            measurement: record.measurement,
            dtuCode: record.dtuCode,
            remark: record.remark,
            isStationDevice: record.isStationDevice,
            initialValue: record.initialValue,
            power: record.power,
            pressure: record.pressure,
            warrantyPeriod: null,
            intervalTime: record.intervalTime,
            tag: record.tag || null
          }
          try {
            const { message } = await updateDevice(form)
            this.$message.success(message)
            this.searchDeviceList()
          } catch(e) {
            console.log(e)
          }
          // const { data } = await getDeviceGroup(record.id)
          // data.enabled = record.enabled
          // this.loading = true
          // updateDeviceGroup(data).then(({ message }) => {
          //   this.$message.success(message)
          //   this.getGroupList(this.pagination.current, this.pagination.pageSize)
          // }).catch((e) => {
          //   console.log(e);
          //   this.$message.error("请求失败")
          // })
        },
        onCancel() {
          record.enabled = record.enabled
        }
      })
    },
    async showConfirm_modifyParameter(record) {
      this.$confirm({
        title: this.$t('device.modifyParameter_confirm_title'),
        content: this.$t('device.modifyParameter_confirm_content'),
        onOk: async () => {
          try {
            const { message } = await putModifyParameter(!record.modifyParameter, record.code)
            this.searchDeviceList()
            this.$message.success(message)
          } catch(e) {
            console.log(e)
          }
        },
        onCancel() {
          record.modifyParameter = record.modifyParameter
        }
      })
    },
    handleProvinceChange(value) {
      this.cities = this.cityData[value];
      this.secondCity = this.cityData[value][0];
    },
    handleSearch() {
      this.pagination.current = 1;
      const ips = document.querySelectorAll(".username .ant-input");
      this.queryParams.query = [];
      ips.forEach(ip => {
        if (ip.dataset["index"]) {
          console.log(ip.dataset['index'], this.columns[+ip.dataset["index"]].key);
          if (ip.value.trim()) {
            this.queryParams.query.push({
              field: this.columns[+ip.dataset["index"]].key,
              value: ip.value
            });
            this.highLightInfo[this.columns[+ip.dataset["index"]].key] =
              ip.value;
          } else {
            this.highLightInfo[this.columns[+ip.dataset["index"]].key] = "";
          }
        }
      });
      this.searchDeviceList();
    },
    gotoDevice(device) {
      this.$store.commit('setDeviceInfo', device)
      this.$router.push({ path: '/equipment/list/submit/edit', query: { key: 'monitor' } })
    },
    handleTableChange(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.searchDeviceList()
    },
    async searchDeviceList(e) {
      this.loading = true;
      if (e) {
        this.pagination.current = 1
      }
      this.queryParams.query[0].value = this.code.split('-').join('')
      const queryParams = JSON.parse(JSON.stringify(this.queryParams))
      queryParams.filter.push({
        field: "mode",
        value: "and"
      })
      try {
        const { data } = await searchDeviceList(
          this.pagination.current,
          this.pagination.pageSize,
          queryParams
        );
        this.list = data.records.map(item => {
          item.organizations = {};
          item.users = {};
          (item?.customer?.users || []).forEach(u => {
            if (u.organizationName) {
              item.organizations[u.organizationName] = u.organizationName
            }
            if (u.realName) {
              item.users[u.realName] = u.realName
            }
          });
          item.organizations = Object.keys(item.organizations).join("，");
          item.users = Object.keys(item.users).join("，");
          item.createdAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss");
          item.updatedAt = moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss");
          item.startTime && (item.startTime = moment(item.startTime).format("YYYY-MM-DD"));
          item.endTime && (item.endTime = moment(item.endTime).format("YYYY-MM-DD"));
          item.status = (item.status || '').split(',')
          return item;
        });
        this.pagination.current = data.current;
        this.pagination.total = data.total;
        this.highLightInfo.forEach((h, i) => {
          h.value = this.queryParams.query.find(q => q.field === h.field).value
        })
      } catch(e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async handleReset(clearFilters, dataIndex) {
      clearFilters();
      this.searchInfo.text[dataIndex] = "";
      this.searchInfo.column[dataIndex] = false;
      const i = this.params.query.find(p => p.field === dataIndex);
      i.value = "";
      this.searchDeviceList();
    },
    routeTo(record) {
      this.$store.commit("setDeviceInfo", record);
      this.$router.push({ path: "/equipment/view" });
    },
    onEdit(record) {
      this.$store.commit("setDeviceInfo", record);
      this.$router.push({ path: "/equipment/list/submit/edit" });
    },
    closeDrawer() {
      this.equipmentDrawer.visible = false;
      this.searchDeviceList();
    },
    removeDevice(id) {
      deleteDevice(id)
        .then(async ({ message }) => {
          this.$message.success(message);
          this.loading = true;
          const { data } = await searchDeviceList(1, 10, this.queryParams);
          this.list = data.records.map(item => {
            item.organizations = {};
            item.users = {};
            (item?.customer?.users || []).forEach(u => {
              if (u.organizationName) {
                item.organizations[u.organizationName] = u.organizationName
              }
              if (u.realName) {
                item.users[u.realName] = u.realName
              }
            });
            item.organizations = Object.keys(item.organizations).join("，");
            item.users = Object.keys(item.users).join("，");
            item.createdAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss");
            item.updatedAt = moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss");
            item.startTime && (item.startTime = moment(item.startTime).format("YYYY-MM-DD"));
            item.endTime && (item.endTime = moment(item.endTime).format("YYYY-MM-DD"));
            item.status = (item.status || '').split(',')
            return item;
          });
          this.pagination.current = data.current;
          this.pagination.pageSize = data.size;
          this.pagination.total = data.total;
          this.loading = false;
        })
        .catch(() => {});
    },
    async exportDevice() {
      this.isExporting = true
      try {
        const { data } = await exportDevice(this.queryParams)
        const url = window.URL.createObjectURL(
          new Blob([data])
        )
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const timestamp = new Date().toLocaleDateString()
        link.download = `设备列表${timestamp}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success(this.$t('messages.es'))
      } catch(e) {
        console.log(e)
      } finally {
        this.isExporting = false
      }
    },
    handleTagChange() {
      const t = this.queryParams.filter.findIndex(f => f.field === "tag")
      if (this.tag) {
        let value = this.tag
        if (value === "EMPTY") {
          value = ""
        }
        if (t > -1) {
          this.queryParams.filter[t].value = value
        } else {
          this.queryParams.filter.push({
            field: "tag",
            value
          })
        }
      } else {
        if (t > -1) {
          this.queryParams.filter.splice(t, 1)
        }
      }
      this.searchDeviceList()
    }
  }
};
</script>

<style lang="less" scoped>
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.equipmentList {
  padding: 15px;
  width: 100%;
  height: 100%;
}
.equipmentList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
span {
  position: relative;
}
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-table-tbody .ant-table-row:nth-child(2n) {
  background: rgb(250, 250, 250);
}
div {
  position: relative;
}
span {
  position: relative;
}
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.icons {
  position: absolute;
  right: 18px;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-select-selection__rendered {
  font-weight: normal;
}
/deep/ .el-table__cell {
  padding: 16px 0;
}
.ant-modal div[aria-hidden="true"] {
  display: none !important;
}
.red {
  color: rgb(232, 33, 39);
}
.yellow {
  color: rgb(255, 104, 28);
}
.green {
  color: rgb(14, 237, 36);
}
</style>
